// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq_faq__Zie8D","rounded":"faq_rounded__zn9e_"};